/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { SkuStatisticsResVo } from './SkuStatisticsResVo';
import {
    SkuStatisticsResVoFromJSON,
    SkuStatisticsResVoFromJSONTyped,
    SkuStatisticsResVoToJSON,
    SkuStatisticsResVoToJSONTyped,
} from './SkuStatisticsResVo';

/**
 * 
 * @export
 * @interface ResponseSkuStatisticsResVo
 */
export interface ResponseSkuStatisticsResVo {
    /**
     * 接口状态码
     * @type {number}
     * @memberof ResponseSkuStatisticsResVo
     */
    code?: number;
    /**
     * 接口返回消息
     * @type {string}
     * @memberof ResponseSkuStatisticsResVo
     */
    message?: string;
    /**
     * 
     * @type {SkuStatisticsResVo}
     * @memberof ResponseSkuStatisticsResVo
     */
    data?: SkuStatisticsResVo;
}

/**
 * Check if a given object implements the ResponseSkuStatisticsResVo interface.
 */
export function instanceOfResponseSkuStatisticsResVo(value: object): value is ResponseSkuStatisticsResVo {
    return true;
}

export function ResponseSkuStatisticsResVoFromJSON(json: any): ResponseSkuStatisticsResVo {
    return ResponseSkuStatisticsResVoFromJSONTyped(json, false);
}

export function ResponseSkuStatisticsResVoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ResponseSkuStatisticsResVo {
    if (json == null) {
        return json;
    }
    return {
        
        'code': json['code'] == null ? undefined : json['code'],
        'message': json['message'] == null ? undefined : json['message'],
        'data': json['data'] == null ? undefined : SkuStatisticsResVoFromJSON(json['data']),
    };
}

export function ResponseSkuStatisticsResVoToJSON(json: any): ResponseSkuStatisticsResVo {
    return ResponseSkuStatisticsResVoToJSONTyped(json, false);
}

export function ResponseSkuStatisticsResVoToJSONTyped(value?: ResponseSkuStatisticsResVo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'code': value['code'],
        'message': value['message'],
        'data': SkuStatisticsResVoToJSON(value['data']),
    };
}

